import { ICommandFactory, instanceOfICommandFactory } from "../../command";
import { IEditCommand } from "./IEditCommand";

export interface IEditCommandFactory<T, TCommand extends IEditCommand<T> = IEditCommand<T>> extends ICommandFactory<T, TCommand> {
}

export function instanceOfIEditCommandFactory<T, TCommand extends IEditCommand<T>>(instance: any): instance is IEditCommandFactory<T, TCommand> {
  return instance
      && instanceOfICommandFactory(instance);
}
